import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getUpsellSubsectionStyles = () => {
  return StyleSheet.create({
    container: {
      paddingVertical: tokens.spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_12,
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center'
    },
    infoTagStyle: {
      marginTop: tokens.spacing.SPACING_8,
      alignSelf: 'center'
    },
    subTextStyle: {
      marginTop: tokens.spacing.SPACING_4
    },
    ctaStyle: {
      marginTop: tokens.spacing.SPACING_8,
      marginBottom: tokens.spacing.SPACING_4,
      alignSelf: 'center'
    }
  });
};